import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['predicateSelect', 'field'];

  connect () {
    this.changePredicate();
  }

  changePredicate () {
    this.fieldTarget.name = this.fieldTarget.id.replace('q_', 'q[') + '_' + this.predicateSelectTarget.value + ']';
  }
}
